import { render, staticRenderFns } from "./StartVideoPlayer.vue?vue&type=template&id=b279f65a&scoped=true&"
import script from "./StartVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./StartVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./StartVideoPlayer.vue?vue&type=style&index=0&id=b279f65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b279f65a",
  null
  
)

export default component.exports